"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _StagingActions = require("../actions/StagingActions");

var _CostPerLeadRecord = _interopRequireDefault(require("settings-ui-sdk/AdsROI/CostPerLeadRecord"));

var _actions = require("settings-ui-sdk/AdsROI/actions");

var _actions2 = require("settings-ui-sdk/AdsAccounts/actions");

var _constants = require("../constants");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  currentCostPerLead: (0, _CostPerLeadRecord.default)(),
  currentROISetting: _constants.ROI_TYPE.DEALS_ROI,
  stagedCostPerLead: (0, _CostPerLeadRecord.default)(),
  stagedROISetting: _constants.ROI_TYPE.DEALS_ROI
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchCostPerLeadActionTypes.SUCCESS, function (state, action) {
  var data = (0, _extends2.default)({}, action.payload.data);
  var costPerLead = (0, _CostPerLeadRecord.default)(action.payload.data ? data : {});
  return state.merge({
    currentCostPerLead: costPerLead,
    stagedCostPerLead: costPerLead
  });
}), (0, _defineProperty2.default)(_handleActions, _actions2.FetchAdAccountsActionTypes.SUCCESS, function (state, action) {
  var roiType = action.payload.data.roiType;
  return state.merge({
    currentROISetting: roiType,
    stagedROISetting: roiType
  });
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.STAGE_UPDATE_ROI_SETTING, function (state, action) {
  return state.mergeIn(['stagedROISetting'], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.STAGE_UPDATE_COST_PER_LEAD, function (state, action) {
  return state.mergeIn(['stagedCostPerLead'], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.SyncROISettingActionTypes.SUCCESS, function (state, action) {
  return state.mergeIn(['currentROISetting'], action.payload.props);
}), (0, _defineProperty2.default)(_handleActions, _actions.SyncCostPerLeadActionTypes.SUCCESS, function (state, action) {
  return state.mergeIn(['currentCostPerLead'], action.payload.props);
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.CLEAR_STAGED_CHANGES, function (state) {
  return state.merge({
    stagedCostPerLead: state.get('currentCostPerLead'),
    stagedROISetting: state.get('currentROISetting')
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;